import CryptoJs from 'crypto-js';

const secretKey = process.env.REACT_APP_CRYPTO_SECRET_KEY;
export const encrypt = (text) => {
    return CryptoJs.AES.encrypt(text, secretKey).toString();
}

export const decrypt = (cipherText) => {
    const bytes = CryptoJs.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJs.enc.Utf8);
}
